export default import.meta.ROLLDOWN_FILE_URL_4tlzPLJ49dq8ZCn54eM03w